<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="充值"
    width="500px"
    @close="handleClose"
  >
    <el-form :model="form" ref="formRef" label-width="100px">
      <el-form-item label="用户姓名">
        <el-input v-model="form.user_name" disabled />
      </el-form-item>
      <el-form-item label="表编号">
        <el-input v-model="form.tableNo" disabled />
      </el-form-item>
      <el-form-item label="充值金额" prop="chargeMoney" :rules="[{ required: true, message: '请输入充值金额', trigger: 'blur' }]">
        <el-input v-model="form.chargeMoney" placeholder="必填，请输入充值金额" />
      </el-form-item>
      <el-form-item label="说明" prop="remark">
        <el-input v-model="form.remark" type="textarea" placeholder="输入说明" :rows="3" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: 'ChargeMeter',
  props: {
    visible: { type: Boolean, default: false },
    chargeData: { type: Object, default: null }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        user_name: '',
        tableNo: '',
        total_fee: '',
        remark: ''
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val && this.chargeData) {
        this.form = {
          user_name: this.chargeData.user_name || '',
          tableNo: this.chargeData.tableNo || '',
          total_fee: '',
          remark: ''
        }
      }
    },
    dialogVisible(val) { this.$emit('update:visible', val) }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
      this.$refs.formRef && this.$refs.formRef.resetFields()
    },
    async handleSubmit() {
      try {
        await this.$refs.formRef.validate()
      } catch { return }
      this.loading = true
      try {
        this.$message.success('充值成功')
        this.$emit('success')
        this.handleClose()
      } catch (e) {
        this.$message.error(e.msg || '充值失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
